import { Component } from '@angular/core';

@Component({
  selector: 'app-mobilesession',
  templateUrl: './mobilesession.component.html',
  styleUrls: ['./mobilesession.component.scss']
})
export class MobilesessionComponent {

}
